var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left-arrow 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0928 14.2207H5.54199C4.86768 14.2207 4.32129 13.6743 4.32129 13C4.32129 12.3257 4.86768 11.7793 5.54199 11.7793H20.0928C20.7671 11.7793 21.3135 12.3257 21.3135 13C21.3135 13.6743 20.7671 14.2207 20.0928 14.2207Z",
    fill: "#51566D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1324 19.9947C10.8355 19.9947 10.5376 19.8867 10.3028 19.669L4.07718 13.895C3.8262 13.6621 3.68411 13.3345 3.68655 12.9917C3.689 12.6494 3.83499 12.3233 4.08939 12.0938L10.4859 6.31985C10.9864 5.86819 11.7583 5.90774 12.21 6.40823C12.6617 6.90871 12.6221 7.68069 12.1216 8.13235L6.71536 13.0122L11.9629 17.8789C12.4571 18.3374 12.4864 19.1099 12.0279 19.604C11.7871 19.8633 11.4605 19.9947 11.1324 19.9947Z",
    fill: "#51566D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBack);
export default __webpack_public_path__ + "static/media/ArrowLeftBack.e3dd7fdf02af90e06b81c58b6dd6be0c.svg";
export { ForwardRef as ReactComponent };